import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

export interface ChargePointListActionsHeaderProps
  extends HeaderContext<GatewayChargePointModel, unknown> {}

export const ChargePointListActionsHeader =
  (): // props: ChargePointListActionsHeaderProps,
  ReactNode => {
    // RENDER ////////////////////////////////////////////////////////////////////

    return null;
  };
